import { Box } from '@fox/atoms';
import { Modal } from 'react-bootstrap';
import styled, { createGlobalStyle } from 'styled-components';

export const SearchTrigger = styled(Box).attrs({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100%',
	height: '100%'
})`
	cursor: pointer;
`;

export const SearchBackdropStyles = createGlobalStyle`
	.site-search-backdrop {
		background-color: ${({ theme }) => theme.palette.common.black};
	}
`;

export const SearchModal = styled(Modal)`
	.modal-content {
		background-color: ${({ theme }) => theme.palette.background.paper};
		color: ${({ theme }) => theme.palette.text.primary};
		border: ${({ theme }) => theme.shape['stroke-default']}px solid ${({ theme }) => theme.palette.elevation.outlined};
		border-radius: ${({ theme }) => theme.website?.shape?.cardMedium ?? theme.shape['radius-md']}px;
		box-shadow: ${({ theme }) => theme.shadows[8]};
	}

	.modal-header {
		padding: ${({ theme }) => theme.spacing(2)};
		border-bottom: ${({ theme }) => theme.shape['stroke-default']}px solid ${({ theme }) => theme.palette.divider};
		border-radius: inherit;
		border-bottom-left-radius: 0;
		border-bottom-right-radius: 0;
	}

	.close {
		color: ${({ theme }) => theme.palette.text.secondary};
		text-shadow: none;
		opacity: 1;
		padding: ${({ theme }) => theme.spacing(2)};
		margin: ${({ theme }) => theme.spacing(-2, -2, -2, 'auto')};
		border-radius: ${({ theme }) => theme.website?.shape?.button ?? theme.shape['radius-xs']}px;

		&:hover {
			color: ${({ theme }) => theme.palette.text.primary};
			background-color: ${({ theme }) => theme.palette.action.hover};
		}

		&:focus-visible {
			outline: ${({ theme }) => theme.shape['stroke-focused']}px solid ${({ theme }) => theme.palette.primary.main};
			outline-offset: ${({ theme }) => theme.spacing(0.5)};
		}
	}
`;

export const SearchResult = styled.div`
	border-bottom: ${({ theme }) => theme.shape['stroke-default']}px solid ${({ theme }) => theme.palette.divider};
`;
